/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PaginatedProductImageList } from '../models/paginated-product-image-list';
import { PaginatedSupplierCatalogueList } from '../models/paginated-supplier-catalogue-list';
import { PaginatedSupplierDeliveryTermsList } from '../models/paginated-supplier-delivery-terms-list';
import { PaginatedSupplierOrderList } from '../models/paginated-supplier-order-list';
import { PaginatedSupplierProductList } from '../models/paginated-supplier-product-list';
import { ProductImage } from '../models/product-image';
import { Supplier } from '../models/supplier';
import { SupplierCatalogue } from '../models/supplier-catalogue';
import { supplierCatalogueClone } from '../fn/supplier/supplier-catalogue-clone';
import { SupplierCatalogueClone$Params } from '../fn/supplier/supplier-catalogue-clone';
import { supplierCataloguesCreate } from '../fn/supplier/supplier-catalogues-create';
import { SupplierCataloguesCreate$Params } from '../fn/supplier/supplier-catalogues-create';
import { supplierCataloguesDestroy } from '../fn/supplier/supplier-catalogues-destroy';
import { SupplierCataloguesDestroy$Params } from '../fn/supplier/supplier-catalogues-destroy';
import { supplierCataloguesList } from '../fn/supplier/supplier-catalogues-list';
import { SupplierCataloguesList$Params } from '../fn/supplier/supplier-catalogues-list';
import { supplierCataloguesPartialUpdate } from '../fn/supplier/supplier-catalogues-partial-update';
import { SupplierCataloguesPartialUpdate$Params } from '../fn/supplier/supplier-catalogues-partial-update';
import { supplierCataloguesRetrieve } from '../fn/supplier/supplier-catalogues-retrieve';
import { SupplierCataloguesRetrieve$Params } from '../fn/supplier/supplier-catalogues-retrieve';
import { supplierCataloguesUpdate } from '../fn/supplier/supplier-catalogues-update';
import { SupplierCataloguesUpdate$Params } from '../fn/supplier/supplier-catalogues-update';
import { SupplierDeliveryTerms } from '../models/supplier-delivery-terms';
import { supplierDeliveryTermsCreate } from '../fn/supplier/supplier-delivery-terms-create';
import { SupplierDeliveryTermsCreate$Params } from '../fn/supplier/supplier-delivery-terms-create';
import { supplierDeliveryTermsDestroy } from '../fn/supplier/supplier-delivery-terms-destroy';
import { SupplierDeliveryTermsDestroy$Params } from '../fn/supplier/supplier-delivery-terms-destroy';
import { supplierDeliveryTermsList } from '../fn/supplier/supplier-delivery-terms-list';
import { SupplierDeliveryTermsList$Params } from '../fn/supplier/supplier-delivery-terms-list';
import { supplierDeliveryTermsPartialUpdate } from '../fn/supplier/supplier-delivery-terms-partial-update';
import { SupplierDeliveryTermsPartialUpdate$Params } from '../fn/supplier/supplier-delivery-terms-partial-update';
import { supplierDeliveryTermsRetrieve } from '../fn/supplier/supplier-delivery-terms-retrieve';
import { SupplierDeliveryTermsRetrieve$Params } from '../fn/supplier/supplier-delivery-terms-retrieve';
import { supplierDeliveryTermsUpdate } from '../fn/supplier/supplier-delivery-terms-update';
import { SupplierDeliveryTermsUpdate$Params } from '../fn/supplier/supplier-delivery-terms-update';
import { SupplierFaq } from '../models/supplier-faq';
import { supplierFaqList } from '../fn/supplier/supplier-faq-list';
import { SupplierFaqList$Params } from '../fn/supplier/supplier-faq-list';
import { SupplierOrder } from '../models/supplier-order';
import { supplierOrdersCancelOrderCreate } from '../fn/supplier/supplier-orders-cancel-order-create';
import { SupplierOrdersCancelOrderCreate$Params } from '../fn/supplier/supplier-orders-cancel-order-create';
import { supplierOrdersCancelOrderRetrieve } from '../fn/supplier/supplier-orders-cancel-order-retrieve';
import { SupplierOrdersCancelOrderRetrieve$Params } from '../fn/supplier/supplier-orders-cancel-order-retrieve';
import { supplierOrdersList } from '../fn/supplier/supplier-orders-list';
import { SupplierOrdersList$Params } from '../fn/supplier/supplier-orders-list';
import { supplierOrdersPartialUpdate } from '../fn/supplier/supplier-orders-partial-update';
import { SupplierOrdersPartialUpdate$Params } from '../fn/supplier/supplier-orders-partial-update';
import { supplierOrdersRetrieve } from '../fn/supplier/supplier-orders-retrieve';
import { SupplierOrdersRetrieve$Params } from '../fn/supplier/supplier-orders-retrieve';
import { supplierOrdersUpdate } from '../fn/supplier/supplier-orders-update';
import { SupplierOrdersUpdate$Params } from '../fn/supplier/supplier-orders-update';
import { supplierPartialUpdate } from '../fn/supplier/supplier-partial-update';
import { SupplierPartialUpdate$Params } from '../fn/supplier/supplier-partial-update';
import { SupplierProduct } from '../models/supplier-product';
import { supplierProductImagesCreate } from '../fn/supplier/supplier-product-images-create';
import { SupplierProductImagesCreate$Params } from '../fn/supplier/supplier-product-images-create';
import { supplierProductImagesDestroy } from '../fn/supplier/supplier-product-images-destroy';
import { SupplierProductImagesDestroy$Params } from '../fn/supplier/supplier-product-images-destroy';
import { supplierProductImagesList } from '../fn/supplier/supplier-product-images-list';
import { SupplierProductImagesList$Params } from '../fn/supplier/supplier-product-images-list';
import { supplierProductImagesPartialUpdate } from '../fn/supplier/supplier-product-images-partial-update';
import { SupplierProductImagesPartialUpdate$Params } from '../fn/supplier/supplier-product-images-partial-update';
import { supplierProductImagesRetrieve } from '../fn/supplier/supplier-product-images-retrieve';
import { SupplierProductImagesRetrieve$Params } from '../fn/supplier/supplier-product-images-retrieve';
import { supplierProductImagesUpdate } from '../fn/supplier/supplier-product-images-update';
import { SupplierProductImagesUpdate$Params } from '../fn/supplier/supplier-product-images-update';
import { supplierProductsCreate } from '../fn/supplier/supplier-products-create';
import { SupplierProductsCreate$Params } from '../fn/supplier/supplier-products-create';
import { supplierProductsDestroy } from '../fn/supplier/supplier-products-destroy';
import { SupplierProductsDestroy$Params } from '../fn/supplier/supplier-products-destroy';
import { supplierProductsList } from '../fn/supplier/supplier-products-list';
import { SupplierProductsList$Params } from '../fn/supplier/supplier-products-list';
import { supplierProductsPartialUpdate } from '../fn/supplier/supplier-products-partial-update';
import { SupplierProductsPartialUpdate$Params } from '../fn/supplier/supplier-products-partial-update';
import { supplierProductsRetrieve } from '../fn/supplier/supplier-products-retrieve';
import { SupplierProductsRetrieve$Params } from '../fn/supplier/supplier-products-retrieve';
import { supplierProductsUpdate } from '../fn/supplier/supplier-products-update';
import { SupplierProductsUpdate$Params } from '../fn/supplier/supplier-products-update';
import { SupplierProfileImage } from '../models/supplier-profile-image';
import { supplierProfileImageUpload } from '../fn/supplier/supplier-profile-image-upload';
import { SupplierProfileImageUpload$Params } from '../fn/supplier/supplier-profile-image-upload';
import { supplierRetrieve } from '../fn/supplier/supplier-retrieve';
import { SupplierRetrieve$Params } from '../fn/supplier/supplier-retrieve';
import { supplierUpdate } from '../fn/supplier/supplier-update';
import { SupplierUpdate$Params } from '../fn/supplier/supplier-update';

@Injectable({ providedIn: 'root' })
export class SupplierService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `supplierRetrieve()` */
  static readonly SupplierRetrievePath = '/msp/api/supplier/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierRetrieve$Response(params?: SupplierRetrieve$Params, context?: HttpContext): Observable<StrictHttpResponse<Supplier>> {
    return supplierRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierRetrieve(params?: SupplierRetrieve$Params, context?: HttpContext): Observable<Supplier> {
    return this.supplierRetrieve$Response(params, context).pipe(
      map((r: StrictHttpResponse<Supplier>): Supplier => r.body)
    );
  }

  /** Path part for operation `supplierUpdate()` */
  static readonly SupplierUpdatePath = '/msp/api/supplier/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierUpdate$Response(params: SupplierUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<Supplier>> {
    return supplierUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierUpdate(params: SupplierUpdate$Params, context?: HttpContext): Observable<Supplier> {
    return this.supplierUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<Supplier>): Supplier => r.body)
    );
  }

  /** Path part for operation `supplierPartialUpdate()` */
  static readonly SupplierPartialUpdatePath = '/msp/api/supplier/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierPartialUpdate$Response(params?: SupplierPartialUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<Supplier>> {
    return supplierPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierPartialUpdate(params?: SupplierPartialUpdate$Params, context?: HttpContext): Observable<Supplier> {
    return this.supplierPartialUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<Supplier>): Supplier => r.body)
    );
  }

  /** Path part for operation `supplierCataloguesList()` */
  static readonly SupplierCataloguesListPath = '/msp/api/supplier/catalogues/';

  /**
   * Enables CRUD access for Suppliers to their own Catalogues.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierCataloguesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierCataloguesList$Response(params?: SupplierCataloguesList$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedSupplierCatalogueList>> {
    return supplierCataloguesList(this.http, this.rootUrl, params, context);
  }

  /**
   * Enables CRUD access for Suppliers to their own Catalogues.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierCataloguesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierCataloguesList(params?: SupplierCataloguesList$Params, context?: HttpContext): Observable<PaginatedSupplierCatalogueList> {
    return this.supplierCataloguesList$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginatedSupplierCatalogueList>): PaginatedSupplierCatalogueList => r.body)
    );
  }

  /** Path part for operation `supplierCataloguesCreate()` */
  static readonly SupplierCataloguesCreatePath = '/msp/api/supplier/catalogues/';

  /**
   * Enables CRUD access for Suppliers to their own Catalogues.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierCataloguesCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierCataloguesCreate$Response(params: SupplierCataloguesCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<SupplierCatalogue>> {
    return supplierCataloguesCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Enables CRUD access for Suppliers to their own Catalogues.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierCataloguesCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierCataloguesCreate(params: SupplierCataloguesCreate$Params, context?: HttpContext): Observable<SupplierCatalogue> {
    return this.supplierCataloguesCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupplierCatalogue>): SupplierCatalogue => r.body)
    );
  }

  /** Path part for operation `supplierCataloguesRetrieve()` */
  static readonly SupplierCataloguesRetrievePath = '/msp/api/supplier/catalogues/{id}/';

  /**
   * Enables CRUD access for Suppliers to their own Catalogues.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierCataloguesRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierCataloguesRetrieve$Response(params: SupplierCataloguesRetrieve$Params, context?: HttpContext): Observable<StrictHttpResponse<SupplierCatalogue>> {
    return supplierCataloguesRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Enables CRUD access for Suppliers to their own Catalogues.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierCataloguesRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierCataloguesRetrieve(params: SupplierCataloguesRetrieve$Params, context?: HttpContext): Observable<SupplierCatalogue> {
    return this.supplierCataloguesRetrieve$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupplierCatalogue>): SupplierCatalogue => r.body)
    );
  }

  /** Path part for operation `supplierCataloguesUpdate()` */
  static readonly SupplierCataloguesUpdatePath = '/msp/api/supplier/catalogues/{id}/';

  /**
   * Enables CRUD access for Suppliers to their own Catalogues.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierCataloguesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierCataloguesUpdate$Response(params: SupplierCataloguesUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<SupplierCatalogue>> {
    return supplierCataloguesUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Enables CRUD access for Suppliers to their own Catalogues.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierCataloguesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierCataloguesUpdate(params: SupplierCataloguesUpdate$Params, context?: HttpContext): Observable<SupplierCatalogue> {
    return this.supplierCataloguesUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupplierCatalogue>): SupplierCatalogue => r.body)
    );
  }

  /** Path part for operation `supplierCataloguesDestroy()` */
  static readonly SupplierCataloguesDestroyPath = '/msp/api/supplier/catalogues/{id}/';

  /**
   * Enables CRUD access for Suppliers to their own Catalogues.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierCataloguesDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierCataloguesDestroy$Response(params: SupplierCataloguesDestroy$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return supplierCataloguesDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Enables CRUD access for Suppliers to their own Catalogues.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierCataloguesDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierCataloguesDestroy(params: SupplierCataloguesDestroy$Params, context?: HttpContext): Observable<void> {
    return this.supplierCataloguesDestroy$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `supplierCataloguesPartialUpdate()` */
  static readonly SupplierCataloguesPartialUpdatePath = '/msp/api/supplier/catalogues/{id}/';

  /**
   * Enables CRUD access for Suppliers to their own Catalogues.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierCataloguesPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierCataloguesPartialUpdate$Response(params: SupplierCataloguesPartialUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<SupplierCatalogue>> {
    return supplierCataloguesPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Enables CRUD access for Suppliers to their own Catalogues.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierCataloguesPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierCataloguesPartialUpdate(params: SupplierCataloguesPartialUpdate$Params, context?: HttpContext): Observable<SupplierCatalogue> {
    return this.supplierCataloguesPartialUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupplierCatalogue>): SupplierCatalogue => r.body)
    );
  }

  /** Path part for operation `supplierCatalogueClone()` */
  static readonly SupplierCatalogueClonePath = '/msp/api/supplier/catalogues/{id}/clone/';

  /**
   * Enables CRUD access for Suppliers to their own Catalogues.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierCatalogueClone()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierCatalogueClone$Response(params: SupplierCatalogueClone$Params, context?: HttpContext): Observable<StrictHttpResponse<SupplierCatalogue>> {
    return supplierCatalogueClone(this.http, this.rootUrl, params, context);
  }

  /**
   * Enables CRUD access for Suppliers to their own Catalogues.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierCatalogueClone$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierCatalogueClone(params: SupplierCatalogueClone$Params, context?: HttpContext): Observable<SupplierCatalogue> {
    return this.supplierCatalogueClone$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupplierCatalogue>): SupplierCatalogue => r.body)
    );
  }

  /** Path part for operation `supplierDeliveryTermsList()` */
  static readonly SupplierDeliveryTermsListPath = '/msp/api/supplier/delivery_terms/';

  /**
   * Provides CRUD access for Suppliers to their own DeliveryTerms objects.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierDeliveryTermsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierDeliveryTermsList$Response(params?: SupplierDeliveryTermsList$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedSupplierDeliveryTermsList>> {
    return supplierDeliveryTermsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Provides CRUD access for Suppliers to their own DeliveryTerms objects.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierDeliveryTermsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierDeliveryTermsList(params?: SupplierDeliveryTermsList$Params, context?: HttpContext): Observable<PaginatedSupplierDeliveryTermsList> {
    return this.supplierDeliveryTermsList$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginatedSupplierDeliveryTermsList>): PaginatedSupplierDeliveryTermsList => r.body)
    );
  }

  /** Path part for operation `supplierDeliveryTermsCreate()` */
  static readonly SupplierDeliveryTermsCreatePath = '/msp/api/supplier/delivery_terms/';

  /**
   * Provides CRUD access for Suppliers to their own DeliveryTerms objects.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierDeliveryTermsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierDeliveryTermsCreate$Response(params: SupplierDeliveryTermsCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<SupplierDeliveryTerms>> {
    return supplierDeliveryTermsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Provides CRUD access for Suppliers to their own DeliveryTerms objects.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierDeliveryTermsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierDeliveryTermsCreate(params: SupplierDeliveryTermsCreate$Params, context?: HttpContext): Observable<SupplierDeliveryTerms> {
    return this.supplierDeliveryTermsCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupplierDeliveryTerms>): SupplierDeliveryTerms => r.body)
    );
  }

  /** Path part for operation `supplierDeliveryTermsRetrieve()` */
  static readonly SupplierDeliveryTermsRetrievePath = '/msp/api/supplier/delivery_terms/{id}/';

  /**
   * Provides CRUD access for Suppliers to their own DeliveryTerms objects.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierDeliveryTermsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierDeliveryTermsRetrieve$Response(params: SupplierDeliveryTermsRetrieve$Params, context?: HttpContext): Observable<StrictHttpResponse<SupplierDeliveryTerms>> {
    return supplierDeliveryTermsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Provides CRUD access for Suppliers to their own DeliveryTerms objects.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierDeliveryTermsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierDeliveryTermsRetrieve(params: SupplierDeliveryTermsRetrieve$Params, context?: HttpContext): Observable<SupplierDeliveryTerms> {
    return this.supplierDeliveryTermsRetrieve$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupplierDeliveryTerms>): SupplierDeliveryTerms => r.body)
    );
  }

  /** Path part for operation `supplierDeliveryTermsUpdate()` */
  static readonly SupplierDeliveryTermsUpdatePath = '/msp/api/supplier/delivery_terms/{id}/';

  /**
   * Provides CRUD access for Suppliers to their own DeliveryTerms objects.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierDeliveryTermsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierDeliveryTermsUpdate$Response(params: SupplierDeliveryTermsUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<SupplierDeliveryTerms>> {
    return supplierDeliveryTermsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Provides CRUD access for Suppliers to their own DeliveryTerms objects.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierDeliveryTermsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierDeliveryTermsUpdate(params: SupplierDeliveryTermsUpdate$Params, context?: HttpContext): Observable<SupplierDeliveryTerms> {
    return this.supplierDeliveryTermsUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupplierDeliveryTerms>): SupplierDeliveryTerms => r.body)
    );
  }

  /** Path part for operation `supplierDeliveryTermsDestroy()` */
  static readonly SupplierDeliveryTermsDestroyPath = '/msp/api/supplier/delivery_terms/{id}/';

  /**
   * Provides CRUD access for Suppliers to their own DeliveryTerms objects.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierDeliveryTermsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierDeliveryTermsDestroy$Response(params: SupplierDeliveryTermsDestroy$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return supplierDeliveryTermsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Provides CRUD access for Suppliers to their own DeliveryTerms objects.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierDeliveryTermsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierDeliveryTermsDestroy(params: SupplierDeliveryTermsDestroy$Params, context?: HttpContext): Observable<void> {
    return this.supplierDeliveryTermsDestroy$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `supplierDeliveryTermsPartialUpdate()` */
  static readonly SupplierDeliveryTermsPartialUpdatePath = '/msp/api/supplier/delivery_terms/{id}/';

  /**
   * Provides CRUD access for Suppliers to their own DeliveryTerms objects.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierDeliveryTermsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierDeliveryTermsPartialUpdate$Response(params: SupplierDeliveryTermsPartialUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<SupplierDeliveryTerms>> {
    return supplierDeliveryTermsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Provides CRUD access for Suppliers to their own DeliveryTerms objects.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierDeliveryTermsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierDeliveryTermsPartialUpdate(params: SupplierDeliveryTermsPartialUpdate$Params, context?: HttpContext): Observable<SupplierDeliveryTerms> {
    return this.supplierDeliveryTermsPartialUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupplierDeliveryTerms>): SupplierDeliveryTerms => r.body)
    );
  }

  /** Path part for operation `supplierFaqList()` */
  static readonly SupplierFaqListPath = '/msp/api/supplier/faq/{locale}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierFaqList()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierFaqList$Response(params: SupplierFaqList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SupplierFaq>>> {
    return supplierFaqList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierFaqList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierFaqList(params: SupplierFaqList$Params, context?: HttpContext): Observable<Array<SupplierFaq>> {
    return this.supplierFaqList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SupplierFaq>>): Array<SupplierFaq> => r.body)
    );
  }

  /** Path part for operation `supplierOrdersList()` */
  static readonly SupplierOrdersListPath = '/msp/api/supplier/orders/';

  /**
   * Allows read and update of Orders where the authenticated user is a Supplier.
   * Order creation and deletion is done by the server or by admins.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierOrdersList()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierOrdersList$Response(params?: SupplierOrdersList$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedSupplierOrderList>> {
    return supplierOrdersList(this.http, this.rootUrl, params, context);
  }

  /**
   * Allows read and update of Orders where the authenticated user is a Supplier.
   * Order creation and deletion is done by the server or by admins.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierOrdersList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierOrdersList(params?: SupplierOrdersList$Params, context?: HttpContext): Observable<PaginatedSupplierOrderList> {
    return this.supplierOrdersList$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginatedSupplierOrderList>): PaginatedSupplierOrderList => r.body)
    );
  }

  /** Path part for operation `supplierOrdersRetrieve()` */
  static readonly SupplierOrdersRetrievePath = '/msp/api/supplier/orders/{id}/';

  /**
   * Allows read and update of Orders where the authenticated user is a Supplier.
   * Order creation and deletion is done by the server or by admins.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierOrdersRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierOrdersRetrieve$Response(params: SupplierOrdersRetrieve$Params, context?: HttpContext): Observable<StrictHttpResponse<SupplierOrder>> {
    return supplierOrdersRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Allows read and update of Orders where the authenticated user is a Supplier.
   * Order creation and deletion is done by the server or by admins.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierOrdersRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierOrdersRetrieve(params: SupplierOrdersRetrieve$Params, context?: HttpContext): Observable<SupplierOrder> {
    return this.supplierOrdersRetrieve$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupplierOrder>): SupplierOrder => r.body)
    );
  }

  /** Path part for operation `supplierOrdersUpdate()` */
  static readonly SupplierOrdersUpdatePath = '/msp/api/supplier/orders/{id}/';

  /**
   * Allows read and update of Orders where the authenticated user is a Supplier.
   * Order creation and deletion is done by the server or by admins.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierOrdersUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierOrdersUpdate$Response(params: SupplierOrdersUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<SupplierOrder>> {
    return supplierOrdersUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Allows read and update of Orders where the authenticated user is a Supplier.
   * Order creation and deletion is done by the server or by admins.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierOrdersUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierOrdersUpdate(params: SupplierOrdersUpdate$Params, context?: HttpContext): Observable<SupplierOrder> {
    return this.supplierOrdersUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupplierOrder>): SupplierOrder => r.body)
    );
  }

  /** Path part for operation `supplierOrdersPartialUpdate()` */
  static readonly SupplierOrdersPartialUpdatePath = '/msp/api/supplier/orders/{id}/';

  /**
   * Allows read and update of Orders where the authenticated user is a Supplier.
   * Order creation and deletion is done by the server or by admins.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierOrdersPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierOrdersPartialUpdate$Response(params: SupplierOrdersPartialUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<SupplierOrder>> {
    return supplierOrdersPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Allows read and update of Orders where the authenticated user is a Supplier.
   * Order creation and deletion is done by the server or by admins.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierOrdersPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierOrdersPartialUpdate(params: SupplierOrdersPartialUpdate$Params, context?: HttpContext): Observable<SupplierOrder> {
    return this.supplierOrdersPartialUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupplierOrder>): SupplierOrder => r.body)
    );
  }

  /** Path part for operation `supplierOrdersCancelOrderRetrieve()` */
  static readonly SupplierOrdersCancelOrderRetrievePath = '/msp/api/supplier/orders/{id}/cancel_order/';

  /**
   * Supplier may cancel an order as a whole, or just some of its OrderProducts.
   * Order's status changes to 'canceled' only if all OrderProducts are canceled
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierOrdersCancelOrderRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierOrdersCancelOrderRetrieve$Response(params: SupplierOrdersCancelOrderRetrieve$Params, context?: HttpContext): Observable<StrictHttpResponse<SupplierOrder>> {
    return supplierOrdersCancelOrderRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Supplier may cancel an order as a whole, or just some of its OrderProducts.
   * Order's status changes to 'canceled' only if all OrderProducts are canceled
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierOrdersCancelOrderRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierOrdersCancelOrderRetrieve(params: SupplierOrdersCancelOrderRetrieve$Params, context?: HttpContext): Observable<SupplierOrder> {
    return this.supplierOrdersCancelOrderRetrieve$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupplierOrder>): SupplierOrder => r.body)
    );
  }

  /** Path part for operation `supplierOrdersCancelOrderCreate()` */
  static readonly SupplierOrdersCancelOrderCreatePath = '/msp/api/supplier/orders/{id}/cancel_order/';

  /**
   * Supplier may cancel an order as a whole, or just some of its OrderProducts.
   * Order's status changes to 'canceled' only if all OrderProducts are canceled
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierOrdersCancelOrderCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierOrdersCancelOrderCreate$Response(params: SupplierOrdersCancelOrderCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<SupplierOrder>> {
    return supplierOrdersCancelOrderCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Supplier may cancel an order as a whole, or just some of its OrderProducts.
   * Order's status changes to 'canceled' only if all OrderProducts are canceled
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierOrdersCancelOrderCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierOrdersCancelOrderCreate(params: SupplierOrdersCancelOrderCreate$Params, context?: HttpContext): Observable<SupplierOrder> {
    return this.supplierOrdersCancelOrderCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupplierOrder>): SupplierOrder => r.body)
    );
  }

  /** Path part for operation `supplierProductImagesList()` */
  static readonly SupplierProductImagesListPath = '/msp/api/supplier/product_images/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierProductImagesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierProductImagesList$Response(params?: SupplierProductImagesList$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedProductImageList>> {
    return supplierProductImagesList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierProductImagesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierProductImagesList(params?: SupplierProductImagesList$Params, context?: HttpContext): Observable<PaginatedProductImageList> {
    return this.supplierProductImagesList$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginatedProductImageList>): PaginatedProductImageList => r.body)
    );
  }

  /** Path part for operation `supplierProductImagesCreate()` */
  static readonly SupplierProductImagesCreatePath = '/msp/api/supplier/product_images/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierProductImagesCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierProductImagesCreate$Response(params: SupplierProductImagesCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductImage>> {
    return supplierProductImagesCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierProductImagesCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierProductImagesCreate(params: SupplierProductImagesCreate$Params, context?: HttpContext): Observable<ProductImage> {
    return this.supplierProductImagesCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProductImage>): ProductImage => r.body)
    );
  }

  /** Path part for operation `supplierProductImagesRetrieve()` */
  static readonly SupplierProductImagesRetrievePath = '/msp/api/supplier/product_images/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierProductImagesRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierProductImagesRetrieve$Response(params: SupplierProductImagesRetrieve$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductImage>> {
    return supplierProductImagesRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierProductImagesRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierProductImagesRetrieve(params: SupplierProductImagesRetrieve$Params, context?: HttpContext): Observable<ProductImage> {
    return this.supplierProductImagesRetrieve$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProductImage>): ProductImage => r.body)
    );
  }

  /** Path part for operation `supplierProductImagesUpdate()` */
  static readonly SupplierProductImagesUpdatePath = '/msp/api/supplier/product_images/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierProductImagesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierProductImagesUpdate$Response(params: SupplierProductImagesUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductImage>> {
    return supplierProductImagesUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierProductImagesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierProductImagesUpdate(params: SupplierProductImagesUpdate$Params, context?: HttpContext): Observable<ProductImage> {
    return this.supplierProductImagesUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProductImage>): ProductImage => r.body)
    );
  }

  /** Path part for operation `supplierProductImagesDestroy()` */
  static readonly SupplierProductImagesDestroyPath = '/msp/api/supplier/product_images/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierProductImagesDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierProductImagesDestroy$Response(params: SupplierProductImagesDestroy$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return supplierProductImagesDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierProductImagesDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierProductImagesDestroy(params: SupplierProductImagesDestroy$Params, context?: HttpContext): Observable<void> {
    return this.supplierProductImagesDestroy$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `supplierProductImagesPartialUpdate()` */
  static readonly SupplierProductImagesPartialUpdatePath = '/msp/api/supplier/product_images/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierProductImagesPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierProductImagesPartialUpdate$Response(params: SupplierProductImagesPartialUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductImage>> {
    return supplierProductImagesPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierProductImagesPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierProductImagesPartialUpdate(params: SupplierProductImagesPartialUpdate$Params, context?: HttpContext): Observable<ProductImage> {
    return this.supplierProductImagesPartialUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProductImage>): ProductImage => r.body)
    );
  }

  /** Path part for operation `supplierProductsList()` */
  static readonly SupplierProductsListPath = '/msp/api/supplier/products/';

  /**
   * Provides Suppliers with CRUD access to their own Products.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierProductsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierProductsList$Response(params?: SupplierProductsList$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedSupplierProductList>> {
    return supplierProductsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Provides Suppliers with CRUD access to their own Products.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierProductsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierProductsList(params?: SupplierProductsList$Params, context?: HttpContext): Observable<PaginatedSupplierProductList> {
    return this.supplierProductsList$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginatedSupplierProductList>): PaginatedSupplierProductList => r.body)
    );
  }

  /** Path part for operation `supplierProductsCreate()` */
  static readonly SupplierProductsCreatePath = '/msp/api/supplier/products/';

  /**
   * Provides Suppliers with CRUD access to their own Products.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierProductsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierProductsCreate$Response(params: SupplierProductsCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<SupplierProduct>> {
    return supplierProductsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Provides Suppliers with CRUD access to their own Products.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierProductsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierProductsCreate(params: SupplierProductsCreate$Params, context?: HttpContext): Observable<SupplierProduct> {
    return this.supplierProductsCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupplierProduct>): SupplierProduct => r.body)
    );
  }

  /** Path part for operation `supplierProductsRetrieve()` */
  static readonly SupplierProductsRetrievePath = '/msp/api/supplier/products/{id}/';

  /**
   * Provides Suppliers with CRUD access to their own Products.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierProductsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierProductsRetrieve$Response(params: SupplierProductsRetrieve$Params, context?: HttpContext): Observable<StrictHttpResponse<SupplierProduct>> {
    return supplierProductsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Provides Suppliers with CRUD access to their own Products.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierProductsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierProductsRetrieve(params: SupplierProductsRetrieve$Params, context?: HttpContext): Observable<SupplierProduct> {
    return this.supplierProductsRetrieve$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupplierProduct>): SupplierProduct => r.body)
    );
  }

  /** Path part for operation `supplierProductsUpdate()` */
  static readonly SupplierProductsUpdatePath = '/msp/api/supplier/products/{id}/';

  /**
   * Provides Suppliers with CRUD access to their own Products.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierProductsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierProductsUpdate$Response(params: SupplierProductsUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<SupplierProduct>> {
    return supplierProductsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Provides Suppliers with CRUD access to their own Products.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierProductsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierProductsUpdate(params: SupplierProductsUpdate$Params, context?: HttpContext): Observable<SupplierProduct> {
    return this.supplierProductsUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupplierProduct>): SupplierProduct => r.body)
    );
  }

  /** Path part for operation `supplierProductsDestroy()` */
  static readonly SupplierProductsDestroyPath = '/msp/api/supplier/products/{id}/';

  /**
   * Provides Suppliers with CRUD access to their own Products.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierProductsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierProductsDestroy$Response(params: SupplierProductsDestroy$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return supplierProductsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Provides Suppliers with CRUD access to their own Products.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierProductsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierProductsDestroy(params: SupplierProductsDestroy$Params, context?: HttpContext): Observable<void> {
    return this.supplierProductsDestroy$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `supplierProductsPartialUpdate()` */
  static readonly SupplierProductsPartialUpdatePath = '/msp/api/supplier/products/{id}/';

  /**
   * Provides Suppliers with CRUD access to their own Products.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierProductsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierProductsPartialUpdate$Response(params: SupplierProductsPartialUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<SupplierProduct>> {
    return supplierProductsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Provides Suppliers with CRUD access to their own Products.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierProductsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  supplierProductsPartialUpdate(params: SupplierProductsPartialUpdate$Params, context?: HttpContext): Observable<SupplierProduct> {
    return this.supplierProductsPartialUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupplierProduct>): SupplierProduct => r.body)
    );
  }

  /** Path part for operation `supplierProfileImageUpload()` */
  static readonly SupplierProfileImageUploadPath = '/msp/api/supplier/upload_profile_image';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supplierProfileImageUpload()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierProfileImageUpload$Response(params: SupplierProfileImageUpload$Params, context?: HttpContext): Observable<StrictHttpResponse<SupplierProfileImage>> {
    return supplierProfileImageUpload(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supplierProfileImageUpload$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  supplierProfileImageUpload(params: SupplierProfileImageUpload$Params, context?: HttpContext): Observable<SupplierProfileImage> {
    return this.supplierProfileImageUpload$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupplierProfileImage>): SupplierProfileImage => r.body)
    );
  }

}
